import {
  documentDeliveryKeys,
  documentDeliveryValues,
  yesOrNoKeys,
  yesOrNoValues,
  lineOfBusinessCodeKeys,
  lineOfBusinessCodeValues,
  quoteViaKeys,
  quoteViaValues,
  bindIssueViaKeys,
  bindIssueViaValues
} from '@/modules/Carrier/helpers/carrier'
import {
  financialTypeKeys,
  financialTypeValues
} from '@/modules/LifeInsure/helpers/life-insure'
import {
  producerTypeKeys,
  producerTypeValues
} from '@/modules/Producer/helpers/producer'
import {
  caseTypeKeys,
  caseTypeValues
} from '@/modules/Case/helpers/case'
import {
  quoteStatusKeys,
  quoteStatusValues
} from '@/modules/Quote/helpers/quote'
import {
  relationKeys,
  relationValues
} from '@/modules/Insured/helpers/insured'

export function translateDocumentDeliveryValue (val: string) {
  const endorsementDocDeliveryIndex = documentDeliveryValues.findIndex((delivary: string) => {
    return delivary === val
  })
  return documentDeliveryKeys[endorsementDocDeliveryIndex]
}

export function translateDocumentDeliveryKey (key: string) {
  const endorsementDocDeliveryIndex = documentDeliveryKeys.findIndex((delivary: string) => {
    return delivary === key
  })
  return documentDeliveryValues[endorsementDocDeliveryIndex]
}

export function translateYesOrNoValue (val: string) {
  const yesOrNoIndex = yesOrNoValues.findIndex((yesOrNo: string) => {
    return yesOrNo === val
  })
  return yesOrNoKeys[yesOrNoIndex]
}

export function translateYesOrNoKey (key: string) {
  const yesOrNoIndex = yesOrNoKeys.findIndex((yesOrNo: string) => {
    return yesOrNo === key
  })
  return yesOrNoValues[yesOrNoIndex]
}

export function translateLineOfBusinessCodeValue (val: string) {
  const codeIndex = lineOfBusinessCodeValues.findIndex((code: string) => {
    return code === val
  })
  return lineOfBusinessCodeKeys[codeIndex]
}

export function translateLineOfBusinessCodeKey (key: string) {
  const codeIndex = lineOfBusinessCodeKeys.findIndex((code: string) => {
    return code === key
  })
  return lineOfBusinessCodeValues[codeIndex]
}

export function translateQuoteViaValue (val: string) {
  const quoteIndex = quoteViaValues.findIndex((quote: string) => {
    return quote === val
  })
  return quoteViaKeys[quoteIndex]
}

export function translateQuoteViaKey (key: string) {
  const quoteIndex = quoteViaKeys.findIndex((quote: string) => {
    return quote === key
  })
  return quoteViaValues[quoteIndex]
}

export function translateBindIssueViaValue (val: string) {
  const viaIndex = bindIssueViaValues.findIndex((via: string) => {
    return via === val
  })
  return bindIssueViaKeys[viaIndex]
}

export function translateBindIssueViaKey (key: string) {
  const viaIndex = bindIssueViaKeys.findIndex((via: string) => {
    return via === key
  })
  return bindIssueViaValues[viaIndex]
}

export function translateFinancialTypeValue (val: string) {
  const financialIndex = financialTypeValues.findIndex((financial: string) => {
    return financial === val
  })
  return financialTypeKeys[financialIndex]
}

export function translateFinancialTypeKey (key: string) {
  const financialIndex = financialTypeKeys.findIndex((financial: string) => {
    return financial === key
  })
  return financialTypeValues[financialIndex]
}

export function translateProducerTypeValue (val: string) {
  const producerIndex = producerTypeValues.findIndex((producer: string) => {
    return producer === val
  })
  return producerTypeKeys[producerIndex]
}

export function translateProducerTypeKey (key: string) {
  const producerIndex = producerTypeKeys.findIndex((producer: string) => {
    return producer === key
  })
  return producerTypeValues[producerIndex]
}

export function translateCaseTypeValue (val: string) {
  const caseTypeIndex = caseTypeValues.findIndex((caseType: string) => {
    return caseType === val
  })
  return caseTypeKeys[caseTypeIndex]
}

export function translateCaseTypeKey (key: string) {
  const caseTypeIndex = caseTypeKeys.findIndex((caseType: string) => {
    return caseType === key
  })
  return caseTypeValues[caseTypeIndex]
}

export function translateQuoteStatusValue (val: string) {
  const quoteStatusIndex = quoteStatusValues.findIndex((quoteStatus: string) => {
    return quoteStatus === val
  })
  return quoteStatusKeys[quoteStatusIndex]
}

export function translateQuoteStatusKey (key: string) {
  const quoteStatusIndex = quoteStatusKeys.findIndex((quoteStatus: string) => {
    return quoteStatus === key
  })
  return quoteStatusValues[quoteStatusIndex]
}

export function translateInsuredRelationValue (val: string) {
  const insuredRelationIndex = relationValues.findIndex((insuredRelation: string) => {
    return insuredRelation === val
  })
  return relationKeys[insuredRelationIndex]
}

export function translateInsuredRelatioKey (key: string) {
  const insuredRelationIndex = relationKeys.findIndex((insuredRelation: string) => {
    return insuredRelation === key
  })
  return relationValues[insuredRelationIndex]
}

export function translateMasterTypeLink (masterType: string) {
  let routeName = ''
  switch (masterType) {
    case 'LIA':
      routeName = 'LifeInsureCaseDetail'
      break
    case 'TICKET':
      routeName = 'TicketDetail'
      break
    case 'ACCOUNT':
      routeName = 'AccountDetailDetail'
      break
    case 'CONTACT':
      routeName = 'ContactDetailDetail'
      break
    case 'POLICY':
      routeName = 'PolicyDetailDetail'
      break
    case 'CARRIER':
      routeName = 'CarrierDetailDetail'
      break
    case 'CARRIER_PRODUCT':
      routeName = 'CarrierProductDetailDetail'
      break
    case 'PRODUCER':
      routeName = 'ProducerDetailDetail'
      break
    case 'QUOTE':
      routeName = 'QuoteDetailDetail'
      break
    case 'VEHICLE':
      routeName = 'VehicleDetailDetail'
      break
    case 'CASE':
      routeName = 'CaseDetailDetail'
      break
    case 'INSURED':
      routeName = 'InsuredDetailDetail'
      break
    case 'PROPERTY':
      routeName = 'PropertyDetailDetail'
      break
    case 'TASK':
      routeName = 'TaskDetail'
      break
    default:
      routeName = 'CaseDashboard'
      break
  }
  return routeName
}
